import React from 'react';
import {
  FDContentContainer, FDHeadlineText, FDIcon, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  ExplorePageSection,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Sections/ExploreSection/ExplorePage/ExplorePageSection';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', align: 'center', color: 'textSecondary' },
  }, overrideReadOnly);

export const ExplorePage = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDContentContainer maxWidth={'lg'}>
      <FDStack direction={'column'} alignItems={'center'} spacing={5}>
        <FDStack direction={'column'} alignItems={'center'} spacing={1}>
          {resource.attr('icon') ? <FDIcon icon={resource.attr('icon')} /> : null}
          <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
        </FDStack>
        <FDStack direction={'column'} alignItems={'center'} spacing={6} width={'100%'}>
          {resource.attr('sections')?.resources().list().map((po) => <ExplorePageSection key={po.id()} resource={po} />)}
        </FDStack>
      </FDStack>
    </FDContentContainer>
  );
};
